import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://identity.infrastructure.aurin.dev',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'infrastructure',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'etl-webapp',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;